import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.service';

@Injectable({ providedIn: 'root' })
export class DealsAutoService extends ApiService<any> {
    // @API deals/auto
    protected serviceName = 'deals/auto';

    constructor() {
        super();
        this.initConnection();
    }

    public async createModelations(mortgageId: string) {
        return this.create({ dealsId: [mortgageId] }, { query: { type: 'change-stages' } })
            .then((result: any) => {
                return result;
            })
            .catch((error) => {
                throw error;
            });
    }
}
